import { API_URL, getApiUrl } from '@/utils/api';
import ApiBase from '@/services/ApiBase';
import { BlogMenuType, MenuItem } from '@/types';

export class BlogService extends ApiBase {
  static baseUrl = getApiUrl(API_URL.PRODUCT, '/blog');

  async getMenu(storeId: string): Promise<BlogMenuType> {
    try {
      return await this.api.getPromisedJSON(`${BlogService.baseUrl}/menu/byStoreId/${storeId}`);
    } catch (error) {
      throw new Error('Error');
    }
  }
}

export class FakeBlogMenuService {
  private readonly returnResponse: MenuItem[];

  constructor(blogMenu: MenuItem[]) {
    this.returnResponse = blogMenu;
  }

  async getMenu(): Promise<{ menuItems: typeof this.returnResponse } | []> {
    return new Promise((resolve, reject) => {
      if (this.returnResponse.length > 0) {
        resolve({ menuItems: this.returnResponse });
      }
      // eslint-disable-next-line prefer-promise-reject-errors
      reject();
    });
  }

  static setupData(): MenuItem[] {
    return [{
      title: 'Header',
      type: 'links',
      subMenus: [{
        title: 'submenu',
        subLinks: [{
          label: '1zpakdo',
          link: '1.html'
        }, {
          label: '2cjvubiuenovep',
          link: '2.html'
        }]
      }, {
        title: 'submenu3',
        subLinks: [{
          label: '5fiiofijz',
          link: '5.html'
        }, {
          label: '6slz^kopda',
          link: '6.html'
        }]
      }]
    }, {
      title: 'Big Menu',
      type: 'images',
      subLinks: [{
        label: '3slazok',
        link: '3.html',
        img: 'https://static.millesima.com/s3/attachements/listing/region_5.jpg'
      }, {
        label: '4kopakdp,ovnrzov',
        link: '4.html',
        img: 'https://static.millesima.com/s3/attachements/listing/region_5.jpg'
      }]
    }];
  }
}
